<template>
  <teleport to="#breadcrumb-wrapper" v-if="isReady">
    <router-link :to="{ name: 'adminDashboard' }"> Dashboard </router-link>
    <ChevronRightIcon class="breadcrumb__icon" />
    <a href="" class="breadcrumb--active">Promos</a>
  </teleport>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Promos</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <button
          class="btn btn-primary shadow-md mr-2"
          @click="openSlideoutPanel"
        >
          Add New Promo
        </button>
      </div>
    </div>
    <entitiesTable
      :filters="filters"
      :controller="'promoes'"
      :columns="columns"
      :title="'Promoes'"
      :overrideForm="'promosForm'"
    ></entitiesTable>
  </div>
</template>

<script>
import entitiesTable from '@/components/entity-table/EntityTable.vue'
import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
import { mapActions } from 'vuex'

export default {
  components: {
    entitiesTable: entitiesTable
  },
  mixins: [breadcrumbMixin],
  data() {
    return {
      filters: [
        { key: 'name', value: 'Name' },
        { key: 'description', value: 'Description' }
      ],
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: 'NAME',
          minWidth: 200,
          responsive: 0,
          field: 'name',
          vertAlign: 'middle',
          print: false,
          download: false
        },
        {
          title: 'DESCRIPTION',
          minWidth: 200,
          responsive: 0,
          field: 'description',
          vertAlign: 'middle',
          print: false,
          download: false
        },
        {
          title: 'DISCOUNT',
          minWidth: 200,
          responsive: 0,
          field: 'discount',
          vertAlign: 'middle',
          print: false,
          download: false
        },
        {
          title: 'VALID FROM',
          minWidth: 200,
          responsive: 0,
          field: 'validFromString',
          vertAlign: 'middle',
          print: false,
          download: false
        },
        {
          title: 'VALID UNTIL',
          minWidth: 200,
          responsive: 0,
          field: 'validToString',
          vertAlign: 'middle',
          print: false,
          download: false
        },
        // For print format
        {
          title: 'NAME',
          field: 'name',
          visible: false,
          print: true,
          download: true
        },
        {
          title: 'DESCRIPTIONS',
          field: 'descriptions',
          visible: false,
          print: true,
          download: true
        },
        {
          title: 'DISCOUNT',
          field: 'discount',
          visible: false,
          print: true,
          download: true
        },
        {
          title: 'DISCOUNT',
          field: 'discount',
          visible: false,
          print: true,
          download: true
        },
        {
          title: 'VALID FROM',
          field: 'validFromString',
          visible: false,
          print: true,
          download: true
        },
        {
          title: 'VALID UNTIL',
          field: 'validToString',
          visible: false,
          print: true,
          download: true
        }
      ]
    }
  },
  methods: {
    ...mapActions('slideover', ['ChangeShownState']),
    openSlideoutPanel() {
      this.ChangeShownState({
        isShown: true,
        title: 'Add Promo',
        component: 'promosForm'
      })
    }
  }
}
</script>
